module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "contacto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row contact-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 right-contact-container",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    attrs: {
      "id": "contacto-aa",
      "action": "send_mail.php",
      "method": "post",
      "enctype": "multipart/form-data"
    }
  }, [_c('p', [_vm._v("Nombre Completo")]), _vm._v(" "), _c('c-input', {
    attrs: {
      "type": "text",
      "name": "names",
      "val": "names"
    }
  }), _vm._v(" "), _c('p', [_vm._v("E-Mail")]), _vm._v(" "), _c('c-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "val": "email"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Teléfono")]), _vm._v(" "), _c('c-input', {
    attrs: {
      "type": "tel",
      "name": "tel",
      "val": "tel"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Mensaje")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "type": "text",
      "name": "comment",
      "val": "comment"
    }
  })], 1), _vm._v(" "), _c('btn-submit', {
    attrs: {
      "classtype": "btn-default",
      "message": "Enviar"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_vm._v("\n     Copyright @2017 All Rights Reserved\n   ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 flecha-container"
  }, [_c('h1', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("CONTACTO")]), _vm._v(" "), _c('img', {
    staticClass: "flecha",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1500",
      "src": require("imgs/icons/Flecha_Blanca.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "contact-info",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Contacto_Locaction.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Encuéntranos"), _c('br'), _vm._v("\n     Blvd. Abelardo L. Rodríguez #828"), _c('br'), _vm._v("\n     Colonia Compuertas C.P. 21218"), _c('br'), _vm._v("\n     Mexicali, B.C.")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-info",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    attrs: {
      "src": require("imgs/icons/Contacto_Telefono.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Llámanos"), _c('br'), _vm._v("\n        Tel: 686-5657663 "), _c('br'), _vm._v("\n        Lada sin costo Nacional: 01-800 7880152"), _c('br'), _vm._v("\n        Lada sin costo Internacional: (011)(52)855-7550643")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("¿Tienes preguntas? "), _c('br'), _vm._v("Estamos para servirte. ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46ac3064"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contacto.vue
// module id = 77
// module chunks = 0